import { zoneSummaryFor } from '@/composables/api/useZoneSummaries';
import { positiveZoneId } from './scheduleGroups';

/**
 * The row {@link PlaylistContainerZoneLine} reads for a zone known only by its id:
 * `{location_zone: {id, display_string, location}}`.
 *
 * The name and the location come from the zone lookup, so the line links the location
 * half and the zone half separately and draws the zone's own mark. Every place that names
 * a schedule's zone uses this, so a zone is never written as plain text.
 * `knownName` is a name the caller already holds, such as the list document's zone name. It is
 * used before the lookup answers, and in place of the lookup's name.
 * Returns null when there is no zone id.
 */
export function zoneLineRowFor(zoneId: unknown, knownName: string | null = null): Record<string, unknown> | null {
    const id = positiveZoneId(zoneId);
    if (id === null) return null;
    const summary = zoneSummaryFor(id);
    return {
        location_zone: {
            id,
            display_string: knownName ?? summary?.displayString ?? `Zone #${id}`,
            location: summary?.location ?? null,
        },
    };
}
